export default __webpack_public_path__ + "static/media/hotei17.f01bf243.webp";